var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 2h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1M3 3a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm8 2.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zm-.5 8.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5M8 23a2 2 0 0 1-2-2h1a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1V5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2z",
    clipRule: "evenodd"
  })));
});
const SvgDuplicate = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicate);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDJIMTZDMTYuNTUyMyAyIDE3IDIuNDQ3NzIgMTcgM1YxOEMxNyAxOC41NTIzIDE2LjU1MjMgMTkgMTYgMTlINUM0LjQ0NzcyIDE5IDQgMTguNTUyMyA0IDE4VjNDNCAyLjQ0NzcyIDQuNDQ3NzIgMiA1IDJaTTMgM0MzIDEuODk1NDMgMy44OTU0MyAxIDUgMUgxNkMxNy4xMDQ2IDEgMTggMS44OTU0MyAxOCAzVjE4QzE4IDE5LjEwNDYgMTcuMTA0NiAyMCAxNiAyMEg1QzMuODk1NDMgMjAgMyAxOS4xMDQ2IDMgMThWM1pNMTEgNS41QzExIDUuMjIzODYgMTAuNzc2MSA1IDEwLjUgNUMxMC4yMjM5IDUgMTAgNS4yMjM4NiAxMCA1LjVWMTEuNUMxMCAxMS43NzYxIDEwLjIyMzkgMTIgMTAuNSAxMkMxMC43NzYxIDEyIDExIDExLjc3NjEgMTEgMTEuNVY1LjVaTTEwLjUgMTRDMTAuNzc2MSAxNCAxMSAxNC4yMjM5IDExIDE0LjVWMTUuNUMxMSAxNS43NzYxIDEwLjc3NjEgMTYgMTAuNSAxNkMxMC4yMjM5IDE2IDEwIDE1Ljc3NjEgMTAgMTUuNVYxNC41QzEwIDE0LjIyMzkgMTAuMjIzOSAxNCAxMC41IDE0Wk04IDIzQzYuODk1NDMgMjMgNiAyMi4xMDQ2IDYgMjFIN0M3IDIxLjU1MjMgNy40NDc3MiAyMiA4IDIySDE5QzE5LjU1MjMgMjIgMjAgMjEuNTUyMyAyMCAyMVY3QzIwIDYuNDQ3NzIgMTkuNTUyMyA2IDE5IDZWNUMyMC4xMDQ2IDUgMjEgNS44OTU0MyAyMSA3VjIxQzIxIDIyLjEwNDYgMjAuMTA0NiAyMyAxOSAyM0g4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";